import http from "@core/fetch";
import { useData } from "@hooks/useData";
import { components } from "@apiSchema";
import { PermissionLevelEnum, PermissionSection } from "@models/PermissionSection";

interface IData {
    permissionLevel: PermissionLevelEnum;
    data: components["schemas"]["LocalProductItemViewModel"][];
    link: string;
}

async function getFoodProfileLocalPopularity(word: string): Promise<IData> {
    const result: components["schemas"]["LocalProductIndexArrayViewModelChainPermissionWrapper"] = await http.get('get food profile local popularity',{ word });

    return {
        permissionLevel: PermissionSection.getPermissionLevel(result.permissionLevel),
        data: result.data?.state ?? [],
        link: result.data?.link ?? '',
    };
}

const idleFetchFn = (_word: string | null): Promise<IData> => Promise.resolve({
    permissionLevel: PermissionLevelEnum.Full,
    data: [],
    link: '',
});

export function useFoodProfileLocalPopularity(word: string | null) {
    const fetchFn = word === null
        ? idleFetchFn
        : getFoodProfileLocalPopularity;

    return useData({
        permissionLevel: PermissionLevelEnum.Full,
        data: [],
        link: '',
    }, fetchFn, word);
}